import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import { User, Role } from '../../types/types'

const initialState: User = {
    id: 0,
    role: 'customer',
    firstName: '',
    lastName: '',
    email: '',
    company: {
        id: 0,
        name: "ABC Corp",
        createdAt: '2025-02-11 23:11:11.829512+00',
        offerings: ['LATTICE']
    },
    christian: false
}

const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        userSet: (_state, action: PayloadAction<User>) => {
            return action.payload;
        },

        roleSet: (state, action: PayloadAction<Role>) => {
            state.role = action.payload
        }
    }
})

export const { userSet, roleSet } = userSlice.actions;
export default userSlice.reducer;
